import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Services from './Services';

export default class Posts extends Component {
    constructor(props) {
        super(props);
        this._services = new Services();

        this.state = {
            posts: []
        }
    }

    componentDidMount() {
        this._services.getPosts()
            .then(apiposts => {
                this.setState({
                    posts: apiposts
                });
            });        
    }

    render() {
    const listPost = this.state.posts.filter(
        (post, index, array) => array.indexOf(post) < 3
    );

    return (
        <Fragment>
            {listPost.map((post, index) => {
                const imageUrl =
                    post?.yoast_head_json?.og_image?.[0]?.url?.replace('http:', 'https:') ||
                    null;

                const title = post?.title?.rendered || 'Sem título';

                const excerpt =
                    post?.excerpt?.rendered?.replace('Read More', '') || '';

                const link = post?.link || '#';

                return (
                    <article key={post?.id || index}>
                        {imageUrl && (
                            <img src={imageUrl} alt={title} />
                        )}

                        <div className="wrapper">
                            <Link
                                to={{ pathname: link }}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <h2>{title}</h2>
                            </Link>

                            <div dangerouslySetInnerHTML={{ __html: excerpt }} />

                            <Link
                                to={{ pathname: link }}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                Continuar lendo
                            </Link>
                        </div>
                    </article>
                );
            })}
        </Fragment>
    );
}
}